<template>
<!-- 应急处置添加 -->
  <div class="log-info">
    <div class="info-head">
      <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
    </div>
    <div class="info-main">
      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item label="应急类型">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option v-for="item in emerType" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用物资">
          <div class="log-item" v-for="(item,index) in form.list" :key="index">
            <el-input placeholder="请输入内容" v-model="item.count" type="number" class="input-with-select" style="width: 20vw;">
              <el-select v-model="item.suppliesId" slot="prepend" style="width:10vw;" placeholder="请选择">
                <el-option v-for="(type,i) in typeList" :key="i" :label="type.name" :value="type.id"></el-option>
              </el-select>
            </el-input>
            <el-button v-if="index==0" type="success" icon="el-icon-plus" @click="addItem" circle style="margin-left:1vw;"></el-button>
            <el-button v-else type="danger" icon="el-icon-delete" circle @click="delItem(index)" style="margin-left:1vw;"></el-button>
          </div>
          <!-- <div class="log-item" v-for="(item,index) in form.old" :key="index">
            <el-input readonly v-model="item.msg" type="number" class="input-with-select">
              <el-select disabled v-model="item.type" slot="prepend" placeholder="请选择">
                <el-option v-for="(type,i) in typeList" :key="i" :label="type.name" :value="type.id"></el-option>
              </el-select>
            </el-input>
          </div> -->
        </el-form-item>
        <el-form-item label="具体内容">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data(){
    return{
      pageTitle:'',
      id:'',
      form:{
        v:'',
        type:'',//更新端
        date:util.myTime.getCurTime(),
        list:[{suppliesId:'',count:''}],
        createBy:'',
        content:'',
      },
      //应急类型
      emerType:[],
      //物资
      typeList:[
        // {id:'1',label:'便携呼吸机',value:'1'},
        // {id:'2',label:'雨衣',value:'2'},
        // {id:'3',label:'绷带',value:'3'},
        // {id:'4',label:'止疼药',value:'4'},
      ],
      // portList:[], //更新端
      // userTypeList:[],//平台端
      isFlag:false,
      groupId:''
    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    var param = this.$route.params
    if(param && param.id!='0'){
      this.id = param.id
      this.pageTitle = '应急处置编辑'
      this.getData()
    }else{
        this.id = ''
        this.pageTitle = '应急处置添加'
    }
    this.getType()
    this.getDataType()
  },
  methods:{
    //获取更新端 emerType
    getType(){
      var that = this
      myHttp.getDictByType({
          type:'handler_type'
      }).then(function(resp){
          if(resp.data.code=='200'){
              var list = resp.data.data.dictList||[]
              that.emerType = list
          }else{
              that.$message.error(resp.data.msg)
          }
      })
    },
    // //获取平台端
    getDataType(){
      var that = this
      myHttp.selectProEmergencySuppliesList({
          projectId:this.groupId
      }).then(function(resp){
          if(resp.data.code=='200'){
              console.log(resp)
              var list = resp.data.data.proEmergencySuppliess||[]
              that.typeList = list
          }else{
              that.$message.error(resp.data.msg)
          }
      })
    },
    // getNameByType(val){
    //     var result = ''
    //     for(var i=0;i<this.portList.length;i++){
    //         if(val == this.portList[i].value){
    //             result = this.portList[i].label
    //         }
    //     }
    //     return result
    // },
    //获取数据
    getData(){
      if(this.id=='1'){
        this.form.type = '1'
        this.form.list = [
          {type:'2',num:'5'}
        ]
        this.form.contain = '大雨来袭，使用应急雨衣。'
      }
        // var that = this
        // myHttp.getSysSystemUpdateLog({
        //     id:this.id
        // }).then(function(resp){
        //     if(resp.data.code=='200'){
        //         var data = resp.data.data.sysSystemUpdateLog
        //         if(data){
        //             that.form.v = data.version
        //             that.form.type = data.type
        //             that.form.date = data.operationTime
        //             that.form.old = data.sysSystemUpdateLogDetails||[]
        //             that.form.useType = data.useType
        //         }
        //     }
        // })
    },
    //添加
    addItem(){
      var obj = {
        type:'2',
        msg:'',
        createBy:''
      }
      this.form.list.unshift(obj)
    },
    //删除
    delItem(index){
      this.form.list.splice(index,1)
    },
    //保存
    onSubmit(){
      // console.log(this.form)
      if(this.isFlag)return;
      this.isFlag = true
      var that = this
      var obj = {
        suppliesJson:JSON.stringify(this.form.list),
        type:this.form.type,
        content:this.form.content,
        createBy:util.session.get('user').id,
        projectId:this.groupId
      }
      // if(this.id==''){
        myHttp.createProEmergencyProcessing(obj).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success("添加成功");
            that.$router.go(-1)
          }else{
            that.$message.error(resp.data.msg);
          }
          that.isFlag = false
        },function(){that.isFlag = false})
      // }else{
      //   obj.id = this.id
      //   myHttp.updateSysSystemUpdateLog(obj).then(function(resp){
      //       if(resp.data.code=='200'){
      //           that.$message.success("修改成功");
      //           that.$router.go(-1)
      //       }else{
      //           that.$message.error(resp.data.msg);
      //       }
      //       that.isFlag = false
      //   },function(){that.isFlag = false})
      // }
      
    },
    //返回
    goBack(){
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped>
  .log-info{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .info-head{
    width: 100%;
    height: 7vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
    border-bottom: 2px solid #409EFF;
    background: #fff;
  }
  .info-main{
    width: 100%;
    height: calc( 100% - 7vh );
    position: relative;
    background: #fff;
    padding: 1vh;
    overflow: auto;
  }
  .log-item{
      display: flex;
      margin-bottom: 1vh;
  }
</style>

<style>
  .info-main .el-form-item__content{
    text-align: left;
    width: 50%;
  }
  .el-input__inner{
    width: 10vw;
  }
</style>